/**
 * extrasCategorySort Filter used for sorting extra categories alphabetically
 */
angular.module('bookingApp').filter('extrasCategorySort',extrasCategorySort);
function extrasCategorySort(){
    function extrasCatSort(input){
        var outter = [];
        outter = Object.keys(input).map(function(k){
            return(input[k]);
        });
        outter.sort(function(a, b){
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name){
                return 1;
            }
            return 0;
        });
        return outter;
    }
    return extrasCatSort;
}